import { BASE_API_URI } from 'src/common/constants';
import { apiRequest } from 'src/common/utils/apiFetch';
import ApiResponseError from 'src/common/utils/apiResponseError';

// Checks if any of the strings contain contact info e.g. emails or phone numbers
// Returns true if any problematic content is found, but will not indicate the specific content.
const checkForContactInfo = async (
  comments: string[],
): Promise<boolean> => {
  const response = await apiRequest(`${BASE_API_URI}support/strings/inspect/`, {
    method: 'POST',
    body: JSON.stringify({ strings: comments }),
  });

  if (response.ok) {
    const { strings } = await response.json();
    return strings.some(Boolean);
  }

  throw new ApiResponseError(response);
};

export default checkForContactInfo;
